import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons/faTriangleExclamation';
import { TypedMemo } from '../../common/types';
import { oauthConsentMessages as messages } from './oauthConsentMessages';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole consent page; each part uses its own slice of it */
import styles from './OAuthConsentView.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The warning for a name that says ChatGPT or Claude with no host of theirs behind the client
 * (design: oauth-consent d1, `.oc-warn`). The server sets `nameLooksLikeKnownApp`; the page only shows it.
 */
const OAuthConsentWarningComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.warning} role="alert">
      <FontAwesomeIcon icon={faTriangleExclamation} className={styles.warningIcon} />
      <div className={styles.warningText}>
        <b className={styles.warningTitle}>{intl.formatMessage(messages.warningTitle)}</b>
        <p className={styles.warningBody}>{withBrandWord(intl.formatMessage(messages.warningText))}</p>
      </div>
    </div>
  );
};

export const OAuthConsentWarning = TypedMemo(OAuthConsentWarningComponent);
